module.exports = __webpack_public_path__ + "static/img/pico45.801ff11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico45.png
// module id = v4Gx
// module chunks = 0